import { ThemeProvider } from '@mui/material'
import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import React, { FC } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import useHotjar from 'react-use-hotjar'
import Footer from './components/footer'
import { AuthProvider } from './context/AuthContext'
import { DrawerProvider } from './context/DrawerContext'
import { QuestionProvider } from './context/QuestionContext'
import { ToastifyProvider } from './context/Toast'
import UserRoutes from './routes/UserRoutes'
import { themeLight } from './theme/theme'
import LocalizedDateProvider from './i18n/LocalizedDateProvider'

import { CompanyProvider } from './context/CompanyContext';

dayjs.extend(timezone);
dayjs.extend(utc);
dayjs.extend((o, c) => {
	const proto = c.prototype;
	const oldFormat = proto.format;
	proto.format = function (formatStr) {
	  const str = oldFormat.call(this, formatStr);
	  return str.charAt(0).toUpperCase() + str.slice(1);
	};
});

const App: FC = function App() {
	const {initHotjar} = useHotjar();
	React.useEffect(() => {
		initHotjar(2783598, 6, false);
	}, [initHotjar]);
	
	return (
		<ToastifyProvider>
			<AuthProvider>
				<LocalizedDateProvider>
					<DrawerProvider>
						<ThemeProvider theme={themeLight}>
							<QuestionProvider>
								<CompanyProvider>
									<Router basename={'/'}>
										<div className='app-shell'>
											<div className='app-content'>
												<UserRoutes />
											</div>
											<Footer/>
										</div>
									</Router>
								</CompanyProvider>
							</QuestionProvider>
						</ThemeProvider>
					</DrawerProvider>
				</LocalizedDateProvider>
			</AuthProvider>
		</ToastifyProvider>
	)
}

export default App;
